import React from "react";
import { observer } from "mobx-react-lite";
import { Alert, Button, Card, Empty, List, Spin } from "antd";
import WorkbenchNotesStore from "../stores/WorkbenchNotesStore";
import { formatDateTime } from "../utils/workbenchNewSubjectView";

const WorkbenchNotesList: React.FC<{ store: WorkbenchNotesStore }> = ({
    store,
}) => (
    <Card className="workbench-new-subject-card">
        {store.loadError && (
            <Alert
                type="error"
                showIcon
                message={store.loadError}
                action={
                    <Button
                        onClick={() => void store.refresh()}
                        loading={store.loading}
                    >
                        Retry
                    </Button>
                }
            />
        )}
        <Spin spinning={store.loading}>
            {store.view &&
                (store.count > 0 ? (
                    <List
                        dataSource={store.view.notes}
                        renderItem={(note) => (
                            <List.Item key={note.id}>
                                <div>
                                    <div className="workbench-note-text">
                                        {note.text}
                                    </div>
                                    <div className="workbench-note-meta">
                                        {note.authorName} ·{" "}
                                        <time dateTime={note.createdAt}>
                                            {formatDateTime(note.createdAt)}
                                        </time>
                                    </div>
                                </div>
                            </List.Item>
                        )}
                    />
                ) : (
                    <Empty description="No notes yet. Use Add quick note to share context for this case." />
                ))}
        </Spin>
    </Card>
);

export default observer(WorkbenchNotesList);
